import { createSlice } from "@reduxjs/toolkit";
const today = new Date();

const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);

const initialState = {
  startDate: firstDay.toISOString().split("T")[0],
  endDate: lastDay.toISOString().split("T")[0],
  filters: true,
  list: [],
};

const promitheiesSlice = createSlice({
  name: "promitheies",
  initialState,
  reducers: {
    setReports(state, action) {
      state.list = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
  },
});

export const { setReports, setStartDate, setEndDate, setFilters } = promitheiesSlice.actions;
export default promitheiesSlice.reducer;
